// src/redux/deleteAppointmentSlice.js
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import Swal from 'sweetalert2';

export const deleteAppointment = createAsyncThunk(
  'appointment/delete',
  async (id, { rejectWithValue }) => {
    const token = localStorage.getItem('token');
    const role = localStorage.getItem('role');

    if (role !== 'superadmin') {
      Swal.fire({
        icon: 'error',
        title: 'Access Denied',
        text: 'Only Superadmin can delete appointments',
      });
      return rejectWithValue('Unauthorized');
    }

    try {
      const response = await fetch(`https://api.thevisaman.in/api/appointments/cancel/${id}`, {
        method: 'DELETE',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Failed to delete appointment');
      }

      Swal.fire({
        icon: 'success',
        title: 'Appointment Deleted',
        text: data.message,
      });

      return data;
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Delete Failed',
        text: error.message,
      });
      return rejectWithValue(error.message);
    }
  }
);

const deleteAppointmentSlice = createSlice({
  name: 'appointmentDelete',
  initialState: {
    status: 'idle',
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(deleteAppointment.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(deleteAppointment.fulfilled, (state) => {
        state.status = 'succeeded';
      })
      .addCase(deleteAppointment.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      });
  },
});

export default deleteAppointmentSlice.reducer;
